import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock } from 'lucide-react';
export function FinalCTA() {
  return <section id="inscripcion" className="py-24 bg-navy relative overflow-hidden" data-id="element-72">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-73">
        <img src="https://cdn.magicpatterns.com/uploads/253mjiKPHQHTDz6KodoTku/ChatGPT_Image_26_may_2026,_17_05_57.png" alt="Background" className="w-full h-full object-cover opacity-10" data-id="element-74" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/95 to-navy/80 bg-[#0D1B3E]" data-id="element-75"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-77">
          <h2 className="font-serif text-4xl md:text-6xl text-cream mb-6" data-id="element-78">
            Tu momento de <span className="text-gold italic" data-id="element-79">RenovarTE</span> es
            AHORA
          </h2>

          <p className="text-xl text-cream/80 font-light mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-80">
            No dejes que pase otro mes sintiéndote estancada. Tienes el poder de
            cambiar tu historia hoy mismo. Únete a las cientos de mujeres que ya
            transformaron su vida con nosotras.
          </p>

          <div className="flex flex-col items-center gap-6 mb-12" data-id="element-81">
            <a href="#" className="w-full md:w-auto bg-gold hover:bg-gold/90 font-bold text-lg md:text-xl py-5 px-10 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1 text-[#0D1B3E]" data-id="element-82">
              QUIERO MI TRANSFORMACIÓN DE 90 DÍAS →
            </a>

            <a href="#diagnostico" className="text-cream/70 hover:text-gold underline underline-offset-4 transition-colors text-sm" data-id="element-83">
              Primero quiero completar mi Diagnóstico gratuito
            </a>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-cream/80 text-sm" data-id="element-84">
            <div className="flex items-center gap-2 bg-cream/5 px-4 py-2 rounded-full border border-cream/10" data-id="element-85">
              <Clock className="w-4 h-4 text-gold" data-id="element-86" />
              <span data-id="element-87">
                Cupos limitados / Próxima cohorte:{' '}
                <strong className="text-cream" data-id="element-88">17 de Junio</strong>
              </span>
            </div>

            <div className="flex items-center gap-2 bg-cream/5 px-4 py-2 rounded-full border border-cream/10" data-id="element-89">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-90" />
              <span data-id="element-91">Satisfacción Garantizada - Pago 100% Seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}